import React, {Component} from "react";
import {connect} from "react-redux";
import {translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as methods from "../../../constants/methods";
import * as resources from "../../../constants/resources";
import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as rccActions from "../../../actions/rccActions";
import * as validationHelper from "../../../helpers/validationHelper";
import * as tooltipHelper from "../../../helpers/tooltipHelper";
import * as formatHelper from "../../../helpers/formatHelper";
import * as windowService from "../../../services/windowService";
import * as modelHelper from "../../../helpers/modelHelper";

import imgPrint from "../../../resources/img/svgicons/print.svg";
import imgSave from "../../../resources/img/svgicons/save.svg";
import imgLoader from "../../../resources/img/loader.svg";
import noImage from "../../../resources/img/no-image.png";
import imgProductFile from "../../../resources/img/svgicons/product-file2.svg";
import imgHelp from "../../../resources/img/svgicons/help2.svg";
import imgEdit from "../../../resources/img/svgicons/edit.svg";
import imgTemplate from "../../../resources/img/svgicons/template.svg";

import Modal from "../generic/Modal";
import CancelButton from "../generic/CancelButton";
import Button from "../generic/Button";
import Input from "../generic/Input";

class PrintModal extends Component {
    constructor(props) {
        super(props);

        let printer = validationHelper.getPrinter(this.props.printerList, this.props.selectedPrinter);

        this.state = {
            activePrinterName: printer ? printer : this.props.printer.name,
            activeTemplateName: validationHelper.getValidItem(this.props.templateList, this.props.templateName),
            numberOfCopies: 1
        };
    }

    handleCloseModalClick = () => {
        window.imageStore.addPrintImage(this.state.activeTemplateName, null);
        this.props.dispatchClosePrintModalAction();
    };

    componentDidMount = () => {
        this.props.dispatchGetPrintPreviewImageAction(this.props.tabId);
    };

    handleTemplateChange = (event) => {
        if (validationHelper.isItemValid(this.props.templateList, event.target.value)) {
            this.props.dispatchGetPrintPreviewImageAction(this.props.tabId, event.target.value);

            this.setState({
                activeTemplateName: event.target.value
            });
        }
    };

    handlePrinterChange = (event) => {
        if (validationHelper.isItemValid(this.props.printerList, event.target.value)) {
            this.setState({
                activePrinterName: event.target.value
            });
        }
    };

    handleSaveAsButtonClick = () => {
        let printImage = window.imageStore.getPrintImageByName(this.state.activeTemplateName);

        if (printImage !== null) {
            windowService.openSaveDialog(printImage.img, formatHelper.formatFileName("IMG", printImage.type));
        }
    };

    getTemplatePathByName = (name) => {
        for (let template of this.props.templateList) {
            if (template.name === name) {
                return template.path;
            }
        }

        return null;
    };

    openEditor = (templatePath) => {
        windowService.openPrintTemplateEditor(
            templatePath,
            function () {
                this.props.dispatchGetPrintTemplatesListAction();
            }.bind(this)
        );
    };

    handleCreateTemplateClick = () => {
        this.openEditor(null);
    };

    handleEditTemplateClick = () => {
        let templatePath = this.getTemplatePathByName(this.state.activeTemplateName);
        this.openEditor(templatePath);
    };

    handleNumberOfCopiesChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            if (event.target.value !== "") {
                this.setState({
                    numberOfCopies: Number(event.target.value)
                });
            } else {
                this.setState({
                    numberOfCopies: ""
                });
            }
        }
    };

    handleNumberOfCopiesMinusClick = () => {
        if (this.state.numberOfCopies > 1) {
            this.setState({
                numberOfCopies: this.state.numberOfCopies - 1
            });
        }
    };

    handleNumberOfCopiesPlusClick = () => {
        this.setState({
            numberOfCopies: Number(this.state.numberOfCopies) + 1
        });
    };

    handleNumberOfCopiesOnBlur = () => {
        if (Number(this.state.numberOfCopies) <= 0) {
            this.setState({
                numberOfCopies: 1
            });
        }
    };

    handlePrintClick = () => {
        this.props.dispatchStartPrintReportSilentAction(
            this.props.tabId,
            this.state.activeTemplateName,
            this.state.activePrinterName,
            this.state.numberOfCopies
        );
    };

    handleExportPdfClick = () => {
        this.props.dispatchExportPrintPreviewToPdfAction(this.props.tabId, this.state.activeTemplateName);
    };

    getPrinterSelectBox = () => {
        if (this.props.printerList.length === 0) {
            return translate("print.noPrintersAvailable");
        }

        let printer,
            printerList = [];

        for (printer of this.props.printerList) {
            printerList.push(<option key={printer.name}>{printer.name}</option>);
        }

        return (
            <select
                className="primary-select width-100"
                value={this.state.activePrinterName}
                onChange={this.handlePrinterChange}
            >
                {printerList}
            </select>
        );
    };

    getTemplateSelectBox = () => {
        if (this.props.templateList.length === 0) {
            return translate("print.noTemplatesAvailable");
        }

        let template,
            templateList = [];
        for (template of this.props.templateList) {
            templateList.push(<option key={template.name}>{template.name}</option>);
        }
        return (
            <select
                className="primary-select width-100"
                value={this.state.activeTemplateName === null ? "" : this.state.activeTemplateName}
                onChange={this.handleTemplateChange}
            >
                {templateList}
            </select>
        );
    };

    getNumberOfCopies = () => {
        return (
            <div className="col-8 flex" onBlur={this.handleNumberOfCopiesOnBlur}>
                <Button
                    className="force-square flex-align-center flex-child"
                    label={<span className="glyphicon glyphicon-minus" />}
                    onClick={this.handleNumberOfCopiesMinusClick}
                />
                <Input
                    className="primary-input text-center flex-child"
                    value={this.state.numberOfCopies}
                    onChange={this.handleNumberOfCopiesChange}
                />
                <Button
                    className="full-height-btn force-square flex-align-center flex-child"
                    label={<span className="glyphicon glyphicon-plus" />}
                    onClick={this.handleNumberOfCopiesPlusClick}
                />
            </div>
        );
    };

    getPrinterImage = (printImage) => {
        if (this.props.loading) {
            return <img alt="loader" src={imgLoader} />;
        }

        if (
            printImage === null ||
            this.state.activePrinterName === "" ||
            this.props.templateList.length === 0 ||
            (this.props.printerList.length === 0 && !this.state.activePrinterName)
        ) {
            if (this.state.activePrinterName === "" || this.props.printerList.length === 0) {
                return (
                    <React.Fragment>
                        <img alt="template" src={noImage} />
                        <label className="no-template-text">{translate("print.noPrintersAvailable")}</label>
                    </React.Fragment>
                );
            }

            if (this.props.templateList.length === 0) {
                return (
                    <React.Fragment>
                        <img alt="template" src={noImage} />
                        <label className="no-template-text">{translate("print.noTemplatesAvailable")}</label>
                    </React.Fragment>
                );
            }

            return <img alt="template" src={noImage} />;
        }

        return <img alt="preview" src={"data:" + printImage.type + ";base64," + printImage.img} />;
    };

    getSaveAsButton = (printImage) => {
        if (this.props.loggedUser.canNotRead(resources.FUNCTION_EXPORT_PRINT_LABEL_TO_IMG)) {
            return null;
        }

        return (
            <Button
                onClick={this.handleSaveAsButtonClick}
                svgBefore={imgSave}
                label={translate("general.saveAs")}
                disabled={this.props.loading || printImage === null}
            />
        );
    };

    getExportPdfButton = (printImage) => {
        if (this.props.loggedUser.canNotRead(resources.FUNCTION_EXPORT_PRINT_LABEL_TO_PDF)) {
            return null;
        }

        return (
            <Button
                onClick={this.handleExportPdfClick}
                svgBefore={imgProductFile}
                label={translate("general.exportPdf")}
                disabled={
                    !(
                        printImage !== null &&
                        this.state.activePrinterName !== null &&
                        this.state.activePrinterName !== "" &&
                        this.state.activeTemplateName !== null &&
                        this.state.numberOfCopies !== "" &&
                        Number(this.state.numberOfCopies) > 0 &&
                        this.props.params.formula &&
                        this.props.params.printData
                    )
                }
            />
        );
    };

    getPrintButton = (printImage) => {
        return (
            <Button
                onClick={this.handlePrintClick}
                svgBefore={imgPrint}
                label={translate("general.print")}
                disabled={
                    !(
                        printImage !== null &&
                        this.state.activePrinterName !== null &&
                        this.state.activePrinterName !== "" &&
                        this.state.activeTemplateName !== null &&
                        this.state.numberOfCopies !== "" &&
                        Number(this.state.numberOfCopies) > 0 &&
                        this.props.params.formula &&
                        this.props.params.printData
                    )
                }
            />
        );
    };

    getPrinterTooltipText = () => {
        if (this.props.printer.comment !== null && this.props.printer.comment !== "") {
            return this.props.printer.comment;
        }

        if (this.props.printer.description !== null && this.props.printer.description !== "") {
            return this.props.printer.description;
        }

        return "";
    };

    getHintTooltip = (tooltipText) => {
        if (this.props.loggedUser.canEdit(resources.COMPONENT_TEMPLATE_HINT)) {
            return (
                <ReactSVG
                    src={imgHelp}
                    alt="help"
                    data-text={translate(tooltipText)}
                    className="force-square size20x20 fit-image fill-primary"
                    wrapper="span"
                    onMouseEnter={tooltipHelper.createTooltip}
                />
            );
        }

        return "";
    };

    getTemplateButtons = () => {
        if (!this.props.printerTemplateEditor || this.props.loggedUser.canNotEdit(resources.FUNCTION_EDIT_TEMPLATE)) {
            return "";
        }

        return (
            <React.Fragment>
                <Button
                    onClick={this.handleCreateTemplateClick}
                    tooltipText={translate("print.createTemplateHint")}
                    svgBefore={imgTemplate}
                    label={translate("print.createTemplate")}
                />
                <Button
                    className="margin-right-auto"
                    onClick={this.handleEditTemplateClick}
                    tooltipText={
                        this.props.templateList.length
                            ? translate("print.editTemplateHint", {name: this.state.activeTemplateName})
                            : translate("print.noEditTemplate")
                    }
                    disabled={!this.props.templateList.length}
                    svgBefore={imgEdit}
                    label={translate("print.editTemplate")}
                />
            </React.Fragment>
        );
    };

    getPrinterSettings = () => {
        return (
            <div className="col-6 flex flex-wrap flex-row-gap-10px">
                <div className="col-12 font-size-1_75em color-primary">{translate("print.printerOptions")}</div>
                <div className="col-12 font-size-1_5em color-primary">{translate("print.defaultSettings")}</div>
                <div className="col-4 color-primary">{translate("print.printerName")}</div>
                <div className="col-8">
                    <span data-text={this.getPrinterTooltipText()} onMouseEnter={tooltipHelper.createTooltip}>
                        {this.state.activePrinterName === null ? "" : this.state.activePrinterName}
                    </span>
                </div>
                <div className="col-4 color-primary">{translate("print.templateName")}</div>
                <div className="col-8">
                    <span>{this.state.activeTemplateName === null ? "" : this.state.activeTemplateName}</span>
                </div>
                <div className="col-12 font-size-1_5em color-primary">{translate("print.chooseSettings")}</div>
                <div className="col-4 color-primary">{translate("print.numberOfCopies")}</div>
                {this.getNumberOfCopies()}
                <div className="col-4 color-primary">{translate("print.choosePrinter")}</div>
                <div className="col-8">
                    <span>{this.getPrinterSelectBox()}</span>
                </div>
                <div className="col-4 flex flex-gap-10px flex-align-center-vertical color-primary">
                    {translate("print.chooseTemplate")}
                    {this.getHintTooltip("print.adminRightsRequired")}
                </div>
                <div className="col-8">
                    <span>{this.getTemplateSelectBox()}</span>
                </div>
            </div>
        );
    };

    getContent = (image) => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getPrinterSettings()}
                <div className="col-6 flex flex-column background-light-grey" style={{alignSelf: "stretch"}}>
                    <div className="col-12 font-2_5vh padding-left-15 padding-right-15 color-primary">
                        {translate("print.printPreview")}
                    </div>
                    <div className="padding-15 flex-child flex fill-flex-space fit-image flex-align-center-horizontal">
                        {this.getPrinterImage(image)}
                    </div>
                </div>
            </React.Fragment>,
            "flex-align-start flex-gap-10px"
        );
    };

    getFooter = (image) => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getTemplateButtons()}
                {this.getPrintButton(image)}
                {this.getExportPdfButton(image)}
                {this.getSaveAsButton(image)}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        let printImage = window.imageStore.getPrintImageByName(this.state.activeTemplateName);

        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("general.print"))}
                content={this.getContent(printImage)}
                footer={this.getFooter(printImage)}
                styles={{
                    minWidth: "60%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    return {
        loggedUser: store.login.loggedUser,
        activeHelp: store.navigation.activeHelp,
        printer: store.rcc.printer,
        clientIdentifier: store.module.clientIdentifier,
        printerTemplateEditor: store.module.printerTemplateEditor,
        selectedPrinter: store.settings.printer,
        printerList: store.rcc.printerList,
        templateName: store.settings.printerTemplate,
        templateList: store.rcc.templateList,
        formulaUnits: store.settings.formulaUnits,
        loading: store.rcc.expected.some(
            (request) =>
                request.tabId === ownProps.tabId &&
                (request.method === methods.PRINTER_EVENT_JPG_EXPORT_DONE ||
                    request.method === methods.PRINTER_EVENT_PDF_EXPORT_DONE)
        ),
        printAsImage: store.settings.printAsImage,
        imageStore: store.navigation.imageStore
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchClosePrintModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PRINT_MODAL));
        },
        dispatchGetPrintPreviewImageAction: (tabId, template = null) => {
            dispatch(rccActions.getPrintPreviewImage(tabId, template));
        },
        dispatchExportPrintPreviewToPdfAction: (tabId, template) => {
            dispatch(rccActions.exportPrintPreviewToPdf(tabId, template));
        },
        dispatchStartPrintReportSilentAction: (tabId, template, printer, pages) => {
            dispatch(rccActions.startPrintReportSilent(tabId, template, printer, pages));
        },
        dispatchGetPrintTemplatesListAction: () => {
            dispatch(rccActions.getPrintTemplatesList());
        }
    };
};

export default PrintModal = connect(mapStoreToProps, mapDispatchToProps)(PrintModal);
